import { render, staticRenderFns } from "./rightTop4.vue?vue&type=template&id=3ebc3c72&scoped=true"
import script from "./rightTop4.vue?vue&type=script&lang=js"
export * from "./rightTop4.vue?vue&type=script&lang=js"
import style0 from "./rightTop4.vue?vue&type=style&index=0&id=3ebc3c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc3c72",
  null
  
)

export default component.exports